var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"display-inline"},[_vm._v("Forecast: Sales Pipeline")]),_c('div',{staticClass:"display-inline ml-3"},[_c('ActiveApiCalls')],1),_c('p',[_vm._v("The current state of the leads pipeline")]),_c('LeadsDashboard'),_c('LeadsKpiGraphs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }